
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { InjectFunction } from "@common/src/utils/decorator";
import { partsQuantityRules } from "@common/src/utils/verify";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import t from "@common/src/i18n/t";

const staff = namespace("staff");
const parts = namespace("parts");
const user = namespace("user");
const app = namespace("app");
const base = namespace("base");
const inventory = namespace("inventory");
const common_base = namespace("common_base");
const setting = namespace("setting");
@InjectFunction("permit", "emptyToLine", "splitThousands", "addCurrencyUnit")
@Component({ components: { MyCheckbox } })
export default class InWareHouseEdit extends Vue {
  @app.Mutation setPBPX;
  @staff.Action getStaffList;
  @parts.Action getPartsList;
  @inventory.Action getInWarehouseDetail;
  @inventory.Action inWarehouseComplete;
  @user.State userData;
  @base.Action getDictionaryList;
  @inventory.Action saveInWarehouse;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_base.State showPlatformParts;
  @inventory.Action queryPartsQtyByWarehouseTree;
  @setting.State fifoStatus;
  @setting.State inboundProductTaxRateMode;
  @setting.State productionBatchNoStatus;
  @inventory.Action generateBatchNumber;
  @inventory.Action queryQtyTreeByInbound;
  get breadData() {
    return [
      { name: t("warehouse.inbound-manage"), path: "/inventory/in-warehouse" },
      { name: this.isAdd ? t("warehouse.add-inbound-order") : t("warehouse.edit-inbound-order") }
    ];
  }
  get isAdd() {
    return this.$route.name === "inWarehouseAdd";
  }
  get isEdit() {
    return this.$route.name === "inWarehouseEdit";
  }
  orderFormDataRules = {
    inboundType: [{ required: true, message: t("warehouse.please-inbound-type"), trigger: "change" }]
  };
  advisorList: any[] = [{}];
  orderFormData: any = {
    inboundType: "",
    inboundUser: "",
    remark: "",
    detailList: [],
    costAmount: "0"
  };
  definitionPartsData: any = {
    partsInfo: {},
    costAmount: "",
    qty: "",
    totalInventory: 0,
    costPrice: "",
    partsCode: "",
    warehouseCode: "",
    shelfCode: "",
    remark: "",
    list: [],
    shelfList: [],
    editing: true
  };
  partsList: any[] = [];
  get setTaxInclude() {
    return this.inboundProductTaxRateMode === "ALL_TAX_INCLUDED";
  }
  get orderId() {
    return this.$route.params.id;
  }
  get selectedParts() {
    return this.orderFormData.detailList.map(i => i.partsCode);
  }
  async created() {
    this.setPBPX(100);
    if (this.fifoStatus === "1") {
      await this.initInboundBatchNo();
    }
    this.init();
  }
  inWarehouseTypeList: any = [];
  loadingObj: any;
  async init() {
    // 不显示采购和退料类型
    this.getDictionaryList("inbound_type").then(data => {
      this.inWarehouseTypeList = data.filter(item => item.dataValue !== "3" && item.dataValue !== "1");
    });
    this.getPartsLists();
    await this.getStaffList({
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    if (!this.isAdd) {
      this.loadingObj = this.$loading({
        lock: true,
        text: t("v3_7_8.the-data-is-loading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      await this.queryInboundAllItemQty();
      this.getInWarehouseDetail({
        inboundNo: this.orderId
      }).then(data => {
        this.orderFormData = data.data;
        const detailList = data.data.detailList || [];
        const detailListLength = detailList.length;
        detailList.forEach((row, index) => {
          if (
            !this.partsList.some(partsItem => {
              return partsItem.partsCode === row.partsCode;
            })
          ) {
            this.partsList.push(row);
          }
          if (this.fifoStatus === "1") {
            row.inboundBatchNo = this.inboundBatchNo;
          }
          row.editing = detailListLength < 50;
          this.handleChooseParts(row.partsCode, index, row, "init");
        });
        this.$nextTick(() => {
          this.loadingObj.close();
        });
      });
    } else {
      this.orderFormData.inboundUser = this.userData.userCode;
      this.handleAddParts(); // 默认添加第一行
    }
  }
  getPartsLists(name = "") {
    this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name,
      notOpadmin: this.showPlatformParts ? "0" : "1"
    }).then(data => {
      this.partsList = (data.data?.list || []).map(item => {
        item.partsNameDesc = item.partsCustomizeCode
          ? `${item.partsNameDesc}(${item.partsCustomizeCode})`
          : item.partsNameDesc;
        return item;
      });
    });
  }
  computedAmount(index) {
    let costAmount = (this.orderFormData.detailList[index].qty || 0) * this.orderFormData.detailList[index].costPrice;
    this.orderFormData.detailList[index].costAmount = costAmount.i18nToFixed();
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    const partsTotal = this.orderFormData.detailList.reduce((preV, curV) => {
      console.log(4441, preV, curV);
      return preV + Number(curV.costAmount);
    }, 0);
    if (Object.is(NaN, partsTotal)) {
      return this.$message.error(t("other.amount-quantity-number-tips"));
    }
    this.orderFormData.costAmount = partsTotal.i18nToFixed();
  }
  searchParts(val) {
    this.getPartsLists(val);
  }

  emitComplete(orderId?) {
    let inboundNo = orderId || this.orderId;
    this.inWarehouseComplete({
      inboundNo: inboundNo
    })
      .then(() => {
        this.$message.success(t("warehouse.inbound-success") as string);
        this.$router.push(`/inventory/in-warehouse-view/${inboundNo}`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  handleChooseParts(val, index, row, type = "manual") {
    if (type === "manual") {
      this.queryPartsQtyByWarehouseTree({
        partsCode: val
      }).then(data => {
        const warehouseList = this.$safeValue(data, "data.warehouseList", []);
        const defaultWarehouse = warehouseList.find(item => item.defaultWarehouse === 1);
        const partsInfo = warehouseList[0];
        let partsData = Object.assign({}, row, {
          partsCode: val,
          partsInfo: partsInfo,
          list: warehouseList,
          totalInventory: data.data.inventoryQty
        });
        if (type === "manual") {
          partsData.qty = "";
          partsData.costAmount = "";
          partsData.warehouseCode = "";
          partsData.shelfCode = "";
          partsData.costPrice =
            this.orderFormData.inboundType === "2" ? partsInfo.costPrice || "" : partsInfo.purchasePrice || "0";
          if (defaultWarehouse) {
            partsData.warehouseCode = defaultWarehouse.warehouseCode;
            this.handleWarehouseChange(partsData, type);
          }
        } else {
          this.handleWarehouseChange(partsData, type);
          partsData.costPrice = row.costPrice || "";
          partsData.costAmount = row.costAmount || "";
        }
        this.orderFormData.detailList.splice(index, 1, partsData);
        this.computedAmount(index);
      });
    } else {
      const partsQtyData = this.allItemQtyList.find(parts => parts.partsCode === val);
      const warehouseList = partsQtyData?.warehouseList || [];
      const partsInfo = warehouseList[0];
      let partsData = Object.assign({}, row, {
        partsCode: val,
        partsInfo: partsInfo,
        list: warehouseList,
        totalInventory: partsQtyData.inventoryQty
      });
      this.handleWarehouseChange(partsData, type);
      partsData.costPrice = partsData.costPrice || "";
      partsData.costAmount = partsData.costAmount || "";
      this.orderFormData.detailList.splice(index, 1, partsData);
      this.computedAmount(index);
    }
  }

  checkAddData(): boolean {
    if (!this.orderFormData.inboundType) {
      this.$message.error(t("warehouse.please-inbound-type") as string);
      return false;
    }
    if (this.orderFormData.detailList.length < 1) {
      this.$message.error(t("setting.add-least-one-component"));
      return false;
    }
    for (let index = 0; index < this.orderFormData.detailList.length; index++) {
      const element = this.orderFormData.detailList[index];
      if (!element.partsCode) {
        this.$message.error(t("v210801.pls-select-inbound-parts"));
        return false;
      }
      if (!element.qty) {
        this.$message.error(t("v210801.pls-input-inbound-num"));
        return false;
      }
      const checkPartsQty = partsQuantityRules(element.qty);
      if (!checkPartsQty.success) {
        this.$message.error(checkPartsQty.msg);
        return false;
      }
      if (this.orderFormData.inboundType === "4" && !element.costPrice) {
        this.$message.error(t("v210801.pls-input-cost-unit"));
        return false;
      }
      if (!element.warehouseCode || !element.shelfCode) {
        this.$message.error(t("v210.please-select-the-warehousing-warehouse-location"));
        return false;
      }
    }
    return true;
  }
  operationName: string = "";
  handleComplete() {
    this.operationName = "complete";
    this.emitSaveInWarehouse();
  }
  handleSaveInWarehouse() {
    this.operationName = "save";
    this.emitSaveInWarehouse();
  }
  emitSaveInWarehouse() {
    (this.$refs["inWarehouseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.btnStartLoading();
        this.saveInWarehouse(this.orderFormData)
          .then(data => {
            if (this.operationName === "save") {
              this.$message.success(t("base.save-success") as string);
              this.$router.push(`/inventory/in-warehouse-view/${data.data.inboundNo}`);
            } else {
              this.emitComplete(data.data.inboundNo);
            }
          })
          .finally(() => {
            this.btnStopLoading();
          });
      } else {
        console.log("error submit!!");
      }
    });
  }
  handleInTypeChange(val) {
    if (val === "2") {
      this.orderFormData.detailList.forEach(item => {
        item.costPrice = item.list[0] ? item.list[0].costPrice : "";
      });
    }
  }
  inboundBatchNo = "";
  async initInboundBatchNo() {
    const data = await this.generateBatchNumber();
    this.inboundBatchNo = data.data;
  }
  async handleAddParts() {
    const row = Object.assign({}, this.definitionPartsData, { taxIncluded: this.fifoStatus === "1" ? "1" : null });
    if (this.fifoStatus === "1") {
      row.inboundBatchNo = this.inboundBatchNo;
    }
    this.orderFormData.detailList.push(row);
  }
  deleteItem(key, index) {
    console.log(key, index);
    this.orderFormData[key].splice(index, 1);
  }
  handleOpPartsShowChange() {
    this.getPartsLists();
  }
  warehousePartsMap: any = {};
  handleWarehouseChange(row, type = "manual") {
    let seletedWarehouse = row.list.find(item => row.warehouseCode === item.warehouseCode);
    row.shelfList = seletedWarehouse && seletedWarehouse.shelfList;
    const defaultShelf = row.shelfList.find(item => item.defaultShelf === 1);
    if (type === "manual") {
      if (defaultShelf) {
        row.shelfCode = defaultShelf.shelfCode;
      } else {
        row.shelfCode = "";
      }
    }
  }
  handleShelfSelectFocus(row) {
    if (!row.warehouseCode) {
      this.$message.error(t("v210.please-select-the-spare-parts-and-warehouse-first"));
    }
  }
  showInConfirmTips: boolean = false;
  handleShowInConfrimTips() {
    (this.$refs["inWarehouseInfo"] as any).validate(valid => {
      if (valid && this.checkAddData()) {
        this.showInConfirmTips = true;
      }
    });
  }
  allItemQtyList: any = [];
  queryInboundAllItemQty() {
    return this.queryQtyTreeByInbound({
      inboundNo: this.orderId
    }).then(data => {
      this.allItemQtyList = data?.data || [];
    });
  }
  handleEditRow(row) {
    row.editing = true;
  }
  handleConfirmRow(row) {
    row.editing = false;
  }
}
